import { Divider } from "@chakra-ui/react";

export const DashDivider = ({
  color = "black.900",
  h = 24,
}: {
  color?: string;
  h?: number;
}) => {
  return <Divider borderColor={color} orientation={"vertical"} h={h} />;
};
